import Image from "next/image";
import Link from "next/link";

export default function NeetSupportCTA({
  title = "Learn More!",
  subtitle = "Attend a FREE 1-to-1 Counselling Session.",
  buttonText = "Book Now",
  buttonHref = "/book-1-on-1-neet-counselling-session",
  imageSrc = "/assets/img/ug_abroad/one-to-one.webp",
}) {
  return (
    <section className="w-full pt-14 pb-5 min-[769px]:pt-20 min-[769px]:pb-8">
      <div className="mx-auto max-w-[1550px] px-4 sm:px-6 lg:px-8">
        <div className="relative min-h-[250px] overflow-visible rounded-3xl border border-orange-100 bg-[#FFF2ED] shadow-[0_12px_34px_rgba(14,96,90,0.10)] min-[769px]:min-h-[230px]">
          {/* Main Content */}
          <div className="relative z-10 flex min-h-[250px] flex-col items-start justify-center overflow-hidden rounded-3xl p-6 text-left sm:p-7 min-[769px]:min-h-[230px] min-[769px]:p-8 min-[769px]:pr-[500px]">
            <h3 className="max-w-3xl text-3xl font-semibold leading-tight text-[#222222] sm:text-4xl min-[769px]:text-[36px]">
              {title}
            </h3>

            <p className="mt-2 max-w-3xl text-2xl font-medium leading-snug text-[#ff9f00] sm:text-3xl min-[769px]:text-[34px]">
              {subtitle}
            </p>

            <div className="mt-7 flex items-center justify-start">
              <Link
                href={buttonHref}
                className="inline-flex items-center justify-center rounded-full bg-[#ff9245] px-5 py-3 text-sm font-bold text-white shadow-md shadow-sky-200 transition duration-300"
              >
                {buttonText}
              </Link>
            </div>

            {/* Mobile + 768px Image */}
            <div className="mt-6 flex w-full justify-center min-[769px]:hidden">
              <div className="relative h-[190px] w-full max-w-[430px] overflow-hidden rounded-xl bg-gray-100 shadow-[0_12px_26px_rgba(0,0,0,0.20)] sm:h-[220px]">
                <Image
                  src={imageSrc}
                  alt="NEET preparation support"
                  fill
                  className="object-cover"
                  sizes="100vw"
                  priority={false}
                />
              </div>
            </div>
          </div>

          {/* Desktop Absolute Image */}
          <div className="absolute right-8 top-[-38px] z-20 hidden w-[390px] min-[769px]:block lg:right-10 lg:top-[-45px] lg:w-[420px]">
            <div className="relative h-[185px] w-full overflow-hidden rounded-xl bg-gray-100 shadow-[0_14px_30px_rgba(0,0,0,0.22)] lg:h-[195px]">
              <Image
                src={imageSrc}
                alt="NEET preparation support"
                fill
                className="object-cover"
                sizes="420px"
                priority={false}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}